/**
 * The inspection module's paths.
 *
 * Two, because there are two audiences and they never meet: `/inspections` is the
 * workshop's board, `/my-inspection` is the driver's walk-around. A single screen
 * switching on role would carry both sets of code into a driver's phone.
 */

export const INSPECTIONS_PATH = '/inspections'
export const MY_INSPECTION_PATH = '/my-inspection'

export const INSPECTION_QUERY_KEYS = {
  vehicleId: 'vehicle',
  severity: 'severity',
  tab: 'tab',
} as const

/** Every open defect on one vehicle — what a vehicle page links to. */
export function vehicleDefectsPath(vehicleId: string): string {
  return `${INSPECTIONS_PATH}?${INSPECTION_QUERY_KEYS.vehicleId}=${vehicleId}`
}
